module.exports = __webpack_public_path__ + "static/media/venue-2.b704fb82.jpg";